import React from 'react';
import Modal from '../../components/ui/Modal';

interface EmailTemplatePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  templateName: string;
  htmlContent: string;
}

const EmailTemplatePreviewModal: React.FC<EmailTemplatePreviewModalProps> = ({
  isOpen,
  onClose,
  templateName,
  htmlContent,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Preview: ${templateName}`}
      size="xlarge"
      className="max-w-6xl"
    >
      <div className="w-full">
        <div className="border border-border rounded-lg overflow-hidden bg-card">
          <div className="bg-muted/50 px-4 py-2.5 border-b border-border">
            <p className="text-sm text-muted-foreground font-medium">
              Email template preview
            </p>
          </div>
          <div
            className="w-full overflow-auto scrollbar-thin"
            style={{ maxHeight: 'calc(90vh - 150px)' }}
          >
            <iframe
              srcDoc={htmlContent}
              className="w-full border-0"
              title={`Email preview: ${templateName}`}
              style={{
                minHeight: '600px',
                width: '100%',
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EmailTemplatePreviewModal;
